import React, { useEffect, useState } from 'react';
import { Modal, Button, Form, Checkbox } from 'react-daisyui';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from 'axios';

interface CohortReportConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onAction: (data: any) => void;
  title?: string;
}

const CohortReportConfirmationModal: React.FC<CohortReportConfirmationModalProps> = ({
  isOpen,
  onClose,
  onAction,
  title = 'Confirm Modal',
}) => {
  const [loading, setLoading] = useState(false);
  const [schoolClass, setSchoolClass] = useState(false);
  const [dayStudent, setDayStudent] = useState(false);
  const [homeStayStudent, setHomeStayStudent] = useState(false);
  const [boarderStudent, setBoarderStudent] = useState(false);
  const [gender, setGender] = useState(false);


  const onConfirm = () => {
    const requestData = {
      school_class: schoolClass,
      day_student: dayStudent,
      boarder: boarderStudent,
      homestay: homeStayStudent,
      gender: gender,
    };

    setLoading(true);
    onAction(requestData);
  };

  useEffect(() => {
    if (isOpen) setLoading(false);
  }, [isOpen]);

  return (
    <Modal open={isOpen}>
      <Modal.Header className="text-2xl font-bold">{title}</Modal.Header>
      <Modal.Body>
        <Form className="w-128">
          <h1 className="font-bold mb-5">Please select the options for the cohort report.</h1>
          <Form.Label title="School Class">
            <Checkbox name="school_class" onChange={(e) => setSchoolClass(e.target.checked)} />
          </Form.Label>
          <Form.Label title="Day Student">
            <Checkbox name="day_student" onChange={(e) => setDayStudent(e.target.checked)} />
          </Form.Label>
          <Form.Label title="Boarder">
            <Checkbox name="boarder" onChange={(e) => setBoarderStudent(e.target.checked)} />
          </Form.Label>
          <Form.Label title="Home-stay">
            <Checkbox name="homestay" onChange={(e) => setHomeStayStudent(e.target.checked)} />
          </Form.Label>
          <Form.Label title="Gender">
            <Checkbox name="gender" onChange={(e) => setGender(e.target.checked)} />
          </Form.Label>
        </Form>
        {loading && <p className='my-3'>
          <div role="alert" className="alert alert-info">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              className="h-6 w-6 shrink-0 stroke-current">
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
            </svg>
            <span>Processing your report. Please wait.</span>
          </div></p>}

      </Modal.Body>

      <Modal.Actions>
        <Button id="CohortReportConfirmationModalCancelButton" type="button" disabled={loading} onClick={onClose}>
          Cancel
        </Button>
        <Button
          id="CohortReportConfirmationModalConfirmButton"
          type="button"
          color="primary"
          className={loading ? 'pointer-events-none' : ''}
          onClick={loading ? undefined : onConfirm}
        >
          {loading ? 'Downloading...' : 'Confirm'}
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

export default CohortReportConfirmationModal;
